import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function PlotReveal({ children, delay = 0, className = "" }) {
  const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={"relative overflow-hidden " + className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={{
        hidden: {},
        visible: {},
      }}
    >
      <motion.div
        variants={{
          hidden: { y: "8%", opacity: 0.001 },
          visible: { y: 0, opacity: 1 },
        }}
        transition={{ duration: 0.85, ease: EASE, delay }}
      >
        {children}
      </motion.div>
      <motion.div
        aria-hidden
        className="absolute inset-0 bg-paper origin-bottom"
        variants={{
          hidden: { scaleY: 1 },
          visible: { scaleY: 0 },
        }}
        transition={{ duration: 0.85, ease: EASE, delay }}
      />
    </motion.div>
  );
}
